
	import Vue from "vue";
	import api from "@/api";

	import TaxRate from "@/data/TaxRate";

	export default Vue.extend({
		data() {
			return {
				isLoading: true as boolean,
				form: {
					values: {
						taxRates: [] as Array<TaxRate>,
					},
				},
			};
		},

		mounted() {
			api.getTaxRates().then((taxRates: Array<TaxRate>) => {
				this.form.values.taxRates = taxRates;
				this.isLoading = false;
			});
		},

		computed: {
			sortedRates(): Array<TaxRate> {
				return this.form.values.taxRates.sort((a: TaxRate, b: TaxRate) => {
					if (parseInt(a.gca_tax_rate_district_number) < parseInt(b.gca_tax_rate_district_number)) return -1;
					if (parseInt(a.gca_tax_rate_district_number) > parseInt(b.gca_tax_rate_district_number)) return 1;
					return 0;
				});
			},
		},

		filters: {
			formatTaxDistrictNumber(number: number): string {
				return number.toString();
			},

			formatTaxRateValue(number: string): string {
				return parseFloat(number).toFixed(2);
			},
		},
	});
